import http from "../utils/http";
import { toast } from "../utils/toast";

// 계약서 리스트 조회
export const getContractsList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/contracts/list', body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 계약서 등록
export const createContracts = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/contracts', body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 계약서 조회
export const getContracts = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/contracts/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 계약서 삭제
export const deleteContracts = (contractIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/contracts/${contractIdx}`)
      .then((res) => {
        toast.success('계약서가 삭제 되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 계약서 서명
export const createContranctsSign = (contractIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/contracts/${contractIdx}/sign`, body)
      .then((res) => {
        toast.success('서명완료 되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getEmployeeSignatures = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/employees/signatures`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}